<template>
  <mds-combo-box
    :label="translate('scheduler.modal.parameters.investment.item.label')"
    :data-set="investmentOptions"
    :selected-items="investment"
    :disabled="!!queriedInvestmentId || !preselectedItem.length"
    :error="!preselectedItem.length"
    :errorText="[translate('scheduler.modal.parameters.investment.item.error')]"
    @input="onChangeValue"
  />
</template>

<script>
import isEmpty from 'lodash/isEmpty'
import MdsComboBox from '@mds/combo-box'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import {
  mapOptions,
  getInvestmentItemText,
} from '@/components/schedulerModal/schedulerSteps/helpers/utils'
import defaultConfig from '@/components/schedulerModal/config/i18n'

export default {
  name: 'InvestmentCombo',
  components: {
    MdsComboBox,
  },
  props: {
    sourceType: {
      type: String,
      default: '',
    },
    investments: {
      type: Object,
      default: () => ({}),
    },
    editedFeed: {
      type: Object,
      default: () => undefined,
    },
    parameterName: {
      type: String,
    },
  },
  mixins: [MwcBaseHelpersMixin],
  data() {
    return {
      defaultConfig,
      investment: [],
      disablebInvestmentItem: false,
      disabledDataset: true,
    }
  },
  watch: {
    investments: {
      deep: true,
      immediate: true,
      handler() {
        this.investment = this.selectSavedOrFirstOption
        const investmentItemText = getInvestmentItemText(
          this.investment[0],
          this.investmentOptions
        )
        this.$store.dispatch('setInvestmentItem', investmentItemText)
      },
    },
    investment: {
      deep: true,
      immediate: true,
      handler(value) {
        this.$emit('investmentChange', value[0])
      },
    },
    sourceType() {
      this.investment = this.selectSavedOrFirstOption
      const investmentItemText = getInvestmentItemText(
        this.investment[0],
        this.investmentOptions
      )
      this.$store.dispatch('setInvestmentItem', investmentItemText)
    },
  },
  computed: {
    selectSavedOrFirstOption() {
      if (this.queriedInvestmentId) {
        return this.queriedInvestmentId
      }
      return this.savedOption ? this.savedOption : this.preselectedItem
    },
    queriedInvestmentId() {
      const { query = {} } = this.$route ?? {}
      const { id = undefined } = query

      const option = this.investmentExists(id)
      return option ? [option.id] : undefined
    },
    savedOption() {
      const selectedOption = this.investmentExists(
        this.editedFeed?.investment_item
      )

      return selectedOption ? [selectedOption.id] : undefined
    },
    investmentOptions() {
      return this.mappedOptions(
        this.investments[this.sourceType],
        this.parameterName
      )
    },
    preselectedItem() {
      for (const option of this.investmentOptions) {
        if (!isEmpty(option.children)) {
          return [option.children[0].value]
        }
      }
      return []
    },
  },
  methods: {
    mappedOptions(options, parameterName) {
      return mapOptions(options, parameterName, this.sourceType, this.translate)
    },
    onChangeValue(e) {
      const [dropdownSelectionId = ''] = e
      const investmentItemText = getInvestmentItemText(
        dropdownSelectionId,
        this.investmentOptions
      )
      this.$store.dispatch('setInvestmentItem', investmentItemText)
      this.investment = [dropdownSelectionId]
    },
    investmentExists(investmentId) {
      for (const investment in this.investments[this.sourceType]) {
        const investments = this.investments[this.sourceType][investment]

        const foundInvestment = investments.find(
          ({ id }) => id?.toUpperCase() === investmentId?.toUpperCase()
        )

        if (foundInvestment) {
          return foundInvestment
        }
      }
      return undefined
    },
  },
}
</script>
